<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        :disabled="!promotion.isReallyActive"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat tile class="flex-grow-0">
        <v-toolbar-title class="title">
          {{ $t("deletePromotion") }}
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="px-8 py-4">
          <span class="overline font-weight-bold">
            {{ $t("promotion") }}
          </span>
          <br />
          <div class="body-2 px-4 pt-2">
            <ul>
              <li>ID: {{ promotion.id_promo }}</li>
              <li>{{ $t("code") }}: {{ promotion.code_promo }}</li>
              <li>
                {{ $t("type") }}: {{ transformTypePromo(promotion.type_promo) }}
              </li>
            </ul>
          </div>
        </div>

        <div class="px-8 py-4">
          <span class="overline font-weight-bold">
            {{ $t("attention") }}
          </span>
          <br />
          <div class="body-2 mb-2 pt-2 px-4">
            <div>
              {{ $t("areYouSureYouWantToDeleteThePromotion") }}
            </div>
            <div class="mt-2">
              {{ $t("deletingPromotionUserRollover") }}
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="confirm"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["promotion"],
  data: () => ({
    dialog: false,
    loading: false,
  }),

  methods: {
    confirm() {
      this.loading = true;

      this.$axios
        .post(
          "administrator/promotions/cancelPromotionById",
          this.$formdata({ id_promo: this.promotion.id_promo })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("refreshPromotions");

          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeDialog() {
      this.dialog = false;
    },

    transformTypePromo(type_promo) {
      const map = {
        afiliado: this.$t("affiliate"),
        cadastro: this.$t("register"),
        deposito: this.$t("deposit"),
        "1ºdeposito": this.$t("firstDeposit"),
      };
      return map[type_promo] || null;
    },
  },
};
</script>
